import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'RequestPhoneCodes/REQUEST_PHONE_CODES_ERROR',
    PENDING: 'RequestPhoneCodes/REQUEST_PHONE_CODES_PENDING',
    SUCCESS: 'RequestPhoneCodes/REQUEST_PHONE_CODES_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
